// extracted by mini-css-extract-plugin
export var container = "_5s-0";
export var error = "_5s-9";
export var label = "_5s-5";
export var light = "_5s-6";
export var md = "_5s-3";
export var sm = "_5s-2";
export var thin = "_5s-8";
export var thinBold = "_5s-7";
export var vertical = "_5s-4";
export var xs = "_5s-1";